import React from "react";
import Admissions2k23card from "../../components/Admissions2025/Admissions2k23card";
import "./Admissionspage.css";
import { pgAdmissionDetails } from "./Admission2025";
import { ugAdmissionDetails } from "./Admission2025";
import { NavLink } from "react-router-dom";

const Admissionspage = () => {
  return (
    <div>
      {/* <div className='breadcrumb'>
        <div className='shadow'>
        </div>
          <h1 className='programmes'>Programmes Offered</h1>
      </div> */}
      <div className="admission">
        <h1>Admission Procedure</h1>
        <p>
          For B.Tech course, allotment to 95% (50% Merit- Regulated Fees and
          45%- Full Fees) seats of the annual intake is made by the Commissioner
          for Entrance Examination (CEE), Government of Kerala from the rank
          list of Kerala Engineering Entrance Examination conducted every year
          by Government of Kerala. 5% seats are reserved for non resident
          Indians (NRI seats). For NRI admission, separate applications are
          invited by Model Engineering College and rank list is prepared on the
          basis of qualifying examination and students are admitted from this
          rank list.
        </p>
      </div>
      <div className="admission2k23holder">
        <h2 className="ugprogrammes">UG programmes</h2>
        <div className="admissioncardholder">
          {ugAdmissionDetails.map((data) => (
            <Admissions2k23card
              key={data.name}
              name={data.name}
              seats={data.seats}
              trade="B.Tech"
              rank={data.rankmerit}
              new={data.new}
            />
          ))}
        </div>
        <div className="feestructure">
          <h2>Fee Structure</h2>
          <table className="fee-table">
            <thead>
              <tr>
                <th>Branch</th>
                <th>Merit Regulated</th>
                <th>Merit Full Fees</th>
                <th>NRI</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>CS, CU, EC, EV</td>
                <td>₹49,613 / Annum</td>
                <td>₹82,688 / Annum</td>
                <td>₹2,00,000 / Annum (+₹1,25,000 Refundable Deposit)</td>
              </tr>
              <tr>
                <td>EEE, EB, ME</td>
                <td>₹44,100 / Annum</td>
                <td>₹77,175 / Annum</td>
                <td>₹1,50,000 / Annum (+₹1,25,000 Refundable Deposit)</td>
              </tr>
              <tr>
                <td>B.Tech Working Professionals</td>
                <td>₹55,000 / Semester</td>
                <td>  </td>
                <td>  </td>
              </tr>
            </tbody>
          </table>
        </div>

        <section className="seatmatrix">
          <h2>Seat Matrix</h2>
          <div className="linegraph">
            <div className="merit-regulated">50%</div>
            <div className="merit-full-fees">45%</div>
            <div className="nri-fees">5%</div>
          </div>
          <div className="legends">
            <p className="merit-legend">Merit Regulated</p>
            <p className="manag-legend">Merit Full Fees</p>
            <p className="nri-legend">NRI</p>
          </div>
          <div className="extras">
            <NavLink to="/placements">
              <h3>Click here to see placement statistics</h3>
            </NavLink>
          </div>
        </section>
        <h2 className="ugprogrammes">PG programmes</h2>
        <div className="admissioncardholder">
          {pgAdmissionDetails.map((data) => (
            <Admissions2k23card
              key={data.name}
              name={data.name}
              seats={data.seats}
              trade="M.Tech"
              new={data.new}
              // rank={0}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Admissionspage;
